import type { FC } from "react";

import { TCardProps } from "@/ui/components/data-display/Card/Card.config";

import { BaseCard } from "./BaseCard";
import { CardIntroduction } from "./CardIntroduction";
import { CardContent } from "./CardContent";

export const Card: FC<TCardProps> = (
  {
    image,
    eyebrow,
    title,
    description,
    tags,
    children,
    ...props
  },
) => (
  <BaseCard
    data-component="Card"
    image={{ ...image, fit: "cover" }}
    ratio="21:9"
    tags={tags}
    {...props}
  >
    <CardIntroduction eyebrow={eyebrow} title={title} description={description} />
    { children ? (
      <CardContent>
        { children }
      </CardContent>
    ): null }
  </BaseCard>
);

Card.displayName = "Card";
